import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

import { computed } from "vue";
import { onboardingApiStore, onboardingStore, sessionStore } from "@/hooks";
import {
  TextButton,
  Stepper,
  Typography,
  FlexBox,
  FlexItem,
  Icon,
} from "@/components/common";
import {
  ConnectGitHubStep,
  SelectRepoStep,
  SummarizeStep,
  GenerateStep,
  ProjectPreview,
} from "@/components/onboarding/steps";


/**
 * A popup for initial onboarding to create a user's first project.
 */
const __default__ = {
  name: "OnboardingPopup",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const userLoggedIn = computed(() => sessionStore.doesSessionExist);

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_spinner_ball = _resolveComponent("q-spinner-ball")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (userLoggedIn.value)
    ? (_openBlock(), _createBlock(_component_q_dialog, {
        key: 0,
        modelValue: _unref(onboardingStore).open,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(onboardingStore).open) = $event)),
        persistent: "",
        maximized: "",
        "transition-show": "slide-up",
        "transition-hide": "slide-down"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "bg-background" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_bar, { class: "bg-background q-mt-md" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FlexBox), { align: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Icon), {
                        variant: "safa",
                        class: "q-mr-md"
                      }),
                      _createVNode(_unref(Typography), {
                        el: "h1",
                        variant: "subtitle",
                        secondary: "",
                        value: "Early Access"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_space),
                  _createVNode(_unref(FlexBox), { align: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TextButton), {
                        text: "",
                        color: "primary",
                        icon: "calendar",
                        label: "Contact Us",
                        style: {"position":"fixed","bottom":"0","right":"0"},
                        class: "q-ma-md",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onboardingStore).handleScheduleCall(false)))
                      }),
                      _createVNode(_unref(TextButton), {
                        text: "",
                        icon: "graph-refresh",
                        label: "Restart",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onboardingApiStore).handleLoadOnboardingState('reset')))
                      }),
                      _createVNode(_unref(TextButton), {
                        text: "",
                        icon: "cancel",
                        label: "Skip Onboarding",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(onboardingApiStore).handleCloseOnboarding()))
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_unref(onboardingStore).loading)
                ? (_openBlock(), _createBlock(_unref(FlexBox), {
                    key: 0,
                    "full-width": "",
                    justify: "center",
                    class: "q-pa-lg q-mt-lg"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_spinner_ball, {
                        class: "nav-gradient",
                        size: "4em"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_unref(FlexBox), {
                "full-width": "",
                justify: "center",
                class: "q-pa-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FlexItem), {
                    parts: "6",
                    class: "q-ma-md"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Typography), {
                        align: "center",
                        el: "h1",
                        variant: "title",
                        value: "Generate Code Documentation"
                      }),
                      _createVNode(_unref(Typography), {
                        align: "center",
                        el: "p",
                        secondary: "",
                        value: "Follow the onboarding steps below to generate documentation for your code."
                      }),
                      _createVNode(_unref(Stepper), {
                        modelValue: _unref(onboardingStore).step,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(onboardingStore).step) = $event)),
                        vertical: "",
                        steps: _unref(onboardingStore).steps,
                        "hide-actions": "",
                        color: "gradient"
                      }, {
                        "1": _withCtx(() => [
                          _createVNode(_unref(ConnectGitHubStep))
                        ]),
                        "2": _withCtx(() => [
                          _createVNode(_unref(SelectRepoStep))
                        ]),
                        "3": _withCtx(() => [
                          _createVNode(_unref(SummarizeStep))
                        ]),
                        "4": _withCtx(() => [
                          _createVNode(_unref(GenerateStep))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "steps"])
                    ]),
                    _: 1
                  }),
                  (_unref(onboardingStore).displayProject)
                    ? (_openBlock(), _createBlock(_unref(FlexItem), {
                        key: 0,
                        parts: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ProjectPreview))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_vShow, !_unref(onboardingStore).loading]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})